import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify, {
  VContent, VLayout, VToolbar, VAppBar, VApp, VMenu, VSpacer, VBtn, VContainer, VFlex,
  VIcon, VFooter, VToolbarTitle, VCard, VCardText, VTextField, VList, VSnackbar, VCheckbox,
  VDataTable, VCardActions, VNavigationDrawer, VListItemAvatar, VCardTitle, VAlert, VForm,
  VSelect, VDialog, VListItem, VListItemTitle, VListItemContent, VListItemSubtitle, VDivider,
  VListItemAction, VTooltip, VSlideXTransition, VProgressLinear, VFadeTransition, VChip,
  VProgressCircular, VExpansionPanel, VExpansionPanelContent, VImg, VAvatar, VExpansionPanels,
  VTextarea, VAutocomplete, VPagination, VExpansionPanelHeader, VRow, VCol, VListItemIcon,
} from 'vuetify/lib';
import 'vuetify/src/styles/main.sass';
import themeManager from '@/services/common/themeManager';

Vue.use(Vuetify, {
  components: {
    VLayout,
    VToolbar,
    VContent,
    VAppBar,
    VApp,
    VMenu,
    VSpacer,
    VBtn,
    VIcon,
    VFooter,
    VContainer,
    VFlex,
    VToolbarTitle,
    VCard,
    VCardText,
    VTextField,
    VList,
    VSnackbar,
    VCheckbox,
    VDataTable,
    VCardActions,
    VNavigationDrawer,
    VListItemAvatar,
    VCardTitle,
    VAlert,
    VForm,
    VSelect,
    VDialog,
    VListItem,
    VListItemTitle,
    VListItemContent,
    VListItemSubtitle,
    VDivider,
    VListItemAction,
    VTooltip,
    VSlideXTransition,
    VProgressLinear,
    VFadeTransition,
    VChip,
    VProgressCircular,
    VExpansionPanel,
    VExpansionPanelContent,
    VImg,
    VAvatar,
    VExpansionPanels,
    VTextarea,
    VAutocomplete,
    VPagination,
    VExpansionPanelHeader,
    VRow,
    VCol,
    VListItemIcon,
  },
});

const opts = {
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: themeManager.defaultTheme,
    },
  },
};

export default new Vuetify(opts);
